import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';


@Component({
  selector: 'error-401',
  standalone: true,
  imports: [],
  templateUrl: './error-401.component.html',
  styles: ``,
})
export class Error401Component {


  constructor(private router: Router, private authService: AuthService) { }

  goBack() {
    if (localStorage.getItem(this.authService.userLastRoute) != null) {
      this.router.navigateByUrl(localStorage.getItem(this.authService.userLastRoute)!);
      return;
    }
  }
}
